export default { 
  goPage(param) {
    let str = '';
    if(param.hasOwnProperty('query')) {
      str += '?'
      Object.keys(param.query).forEach(key=> {
        str+=key+'='+ param.query[key] +'&'
      });
      str = str.substr(0,str.length-1)
    }
    let url = '#/'+ param.name + str
    location.href = url
  }
}


// WEBPACK FOOTER //
// ./src/js/util.js